import haWrapper from './ha-wrapper';
import {post} from './fetch-wrapper';

export function log(data = {}) {
    const urlPrefix = haWrapper.apiPrefix;
    if (!urlPrefix) {
        return;
    }
    post(`/${urlPrefix}/api/logger`, {data});
}

export function logNoListingUrl(boardId, listingId) {
    log({message: 'No listing url', boardId, listingId});
}

export default {
    log,
    logNoListingUrl
};


// WEBPACK FOOTER //
// ./src/universal/utils/logger.js